<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { vodafoneLabNewsletterMixin } from "../../modules/vodafone_lab_mixins_module.js";
import { VodafoneLab } from "../../modules/vodafone_lab_module.js";
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js";
import { get } from "lodash";

export default {
  mixins: [vodafoneLabNewsletterMixin, fandomBasicMixin],
  mounted() {
    Vue.nextTick(() => {
      const newsletterRejected = Fandom.readCookie("vodafone-lab-newsletter-rejected");
      const newsletterSubcribed = Fandom.readCookie("vodafone-lab-newsletter-subscribed");
      const timeoutSeconds = get(this, ["content", "timeout"], 90);
      if (!newsletterRejected && !newsletterSubcribed && !this.mainContent.prevent_newsletter_modal) {
        setTimeout(() => {
          if (!!window.wa_gc) {
            const digitalData = Fandom.deepClone(window.digitalData);
            digitalData.link_name = `${VodafoneLab.getPageName()}:Newsletter subscription`;
            window.wa_gc(digitalData, "link");
            console.log("%cExecuted wa_gc(digitalData, 'link')", "background: #222; color: #bada55; padding: .5rem;", digitalData);
          }
          $(this.$refs["modal"]).modal("show");
        }, parseInt(timeoutSeconds) * 1000);
      }
      $(this.$refs["modal"]).on("hide.bs.modal", () => {
        this.rejectNewsletter();
      });
    });
  },
  methods: {
    hideModal() {
      $(this.$refs["modal"]).modal("hide");
    },
    rejectNewsletter() {
      Fandom.setCookie("vodafone-lab-newsletter-rejected", true);
    },
    trackNewsletterSubscription(data) {
      sendFandomAnalyticsEvent("Newsletter", "Newsletter Registration - Popup", data.label);
    }
  }
};
</script>

<template>
  <div modal-newsletter-component modal-components>
    <div id="modal-newsletter" ref="modal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content" v-easyadmin="easyadminId" :class="contentType">
          <div class="modal-header border-bottom-0 pb-0">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center px-4 px-md-5 pb-5 pt-0 pt-md-4">
            <div class="row justify-content-center">
              <div class="col-12 col-md-6 col-lg-4 d-flex align-items-center justify-content-center pb-3 pb-md-0">
                <img :src="content.image.url" v-if="content.image" class="icon"/>
              </div>
              <div class="col-12 col-md-6 col-lg-8 align-items-center text-left">
                <h3 class="font-weight-normal text-gray-900">{{content.title}}</h3>
                <p class="small font-weight-normal text-gray-900" v-if="content.description" v-html="content.description"></p>
              </div>
              <newsletter-form @subscribed="trackNewsletterSubscription($event)" class="col-12 text-gray-900 pt-md-3" :content="content" :opt-container-content="layoutContent"></newsletter-form>
              <div class="col-12 text-center">
                <a href="javascript:void(0)" class="small" @click.stop.prevent="hideModal">{{ft("globals.newsletter_not_interested")}}</a>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[modal-newsletter-component] {

  .icon {
    max-width: 40%;

    @include media-breakpoint-up(md) {
      max-width: 65%;
    }
  }
}
</style>
